module.exports = __webpack_public_path__ + "img/3.00964147.png";